import React from "react"

function Integration(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M22.38 7.95c.27 0 .5.09.69.28s.29.41.29.68v12.63c0 .25-.09.47-.28.66s-.41.28-.68.28h-7.34c-.27 0-.49-.09-.68-.28s-.28-.41-.28-.66v-2.16H1.71c-.16 0-.31-.03-.46-.09s-.28-.16-.39-.28-.18-.27-.22-.42-.04-.32-.01-.49v-.02l1.36-6.61c.03-.08.06-.15.09-.22s.07-.14.12-.2c-.05-.08-.08-.16-.11-.23s-.04-.16-.04-.26v-7.9c0-.31.11-.57.33-.79s.48-.32.77-.32h15.07c.3 0 .55.11.77.32s.33.47.33.79v5.3h3.06zm-8.27 3.98H3.23l-1.27 6.14H14.1v-6.14zm0-3.02c0-.27.09-.49.28-.68s.41-.28.68-.28h2.95V2.86H3.38v7.48h10.73V8.91zm7.92.35h-6.61v11.93h6.61V9.26zm-3.85 1.38a.475.475 0 01-.13-.35c0-.12.05-.23.14-.33s.21-.14.35-.14h.66c.14 0 .26.05.35.14s.14.2.14.33c0 .14-.05.26-.14.35s-.21.14-.35.14h-.66c-.16 0-.28-.05-.36-.14zm1.21 8.85c.15.15.22.32.22.53s-.07.38-.22.53-.32.22-.53.22-.38-.07-.53-.22-.22-.32-.22-.53.07-.38.22-.53.32-.22.53-.22.39.07.53.22zm1.56-9.48a.378.378 0 00-.28-.12c-.12 0-.23.04-.3.12s-.12.17-.12.28c0 .12.04.23.12.3s.18.12.3.12c.11 0 .2-.04.28-.12s.12-.18.12-.3c0-.11-.04-.2-.12-.28z"
        className="about-icons"
      />
    </svg>
  )
}

export default Integration
